import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import AiUsageDashboard from '../configuration-settings/AiUsageDashboard';

const AiUsagePage: React.FC = () => {
  const { colors } = useTheme();

  return (
    <div className={cn('flex flex-col flex-1 min-h-0 min-w-0', colors.background)}>
      <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden dashboard-scrollbar">
        <div className="p-4 sm:p-6 lg:p-8 w-full">
          <AiUsageDashboard embedded={false} />
        </div>
      </div>
    </div>
  );
};

export default AiUsagePage;
